export const LAST_SERVER_ACTIVITY_KEY = 'multaqa.lastServerActivity'

let inMemoryActivity = 0

/** Record that a non-401 API response renewed the server-side idle timer. */
export function recordServerActivity(): number {
  const activity = Date.now()
  inMemoryActivity = activity

  try {
    window.localStorage.setItem(LAST_SERVER_ACTIVITY_KEY, String(activity))
  } catch {
    // Storage may be disabled; the in-memory timestamp remains authoritative in this tab.
  }

  return activity
}

/** Return the newest known response time across this tab and other tabs. */
export function lastServerActivity(): number {
  try {
    const stored = window.localStorage.getItem(LAST_SERVER_ACTIVITY_KEY)
    if (stored !== null) {
      const activity = Number(stored)
      if (Number.isFinite(activity) && activity >= 0) {
        return Math.max(inMemoryActivity, activity)
      }
    }
  } catch {
    // Storage may be unavailable; the in-memory timestamp is the fallback.
  }

  return inMemoryActivity
}

/** Subscribe to activity writes from other tabs. */
export function subscribeToServerActivity(listener: (activity: number) => void): () => void {
  const handleStorage = (event: StorageEvent) => {
    if (event.key !== LAST_SERVER_ACTIVITY_KEY && event.key !== null) return

    const activity = lastServerActivity()
    if (activity > 0) listener(activity)
  }

  window.addEventListener('storage', handleStorage)
  return () => window.removeEventListener('storage', handleStorage)
}
